import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-main">
        <div className="newsletter-section">
          <h2>Connect</h2>
          <p>build@dilverbloom.online</p>
        </div>

        <div className="footer-links-section">
          <div className="links-column">
            <h3>Let us help you</h3>

            <Link to="/shipping" onClick={toTop}>
              Shipping
            </Link>
            <Link to="/returns" onClick={toTop}>
              Returns Policy
            </Link>

            <Link to="/contact" onClick={toTop}>
              Contact Us
            </Link>
            <Link to="/terms" onClick={toTop}>
              Terms
            </Link>

            <Link to="/privacy" onClick={toTop}>
              Privacy
            </Link>
            <Link to="/cookies" onClick={toTop}>
              Cookie Policy
            </Link>
            <Link to="/faqs" onClick={toTop}>
              FAQs
            </Link>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2026 Dilverbloom</p>
      </div>
    </footer>
  );
}

export default Footer;
